import { Button as GlueBtn } from '@tencent/glue-react-ui';
import { withAdpCombine } from '../../config/context/config';
export var Button = withAdpCombine(GlueBtn);
Object.assign(Button, {
  Group: withAdpCombine(GlueBtn.Group)
});